// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "recommend__wrapper-2IiLq";
var _4 = "tooltip-WBNi9";
var _5 = "tooltip_recommend-JZDPH";
var _6 = "info-1bkho";
var _7 = "tooltip_popper-2NYrS";
var _8 = "tooltip_withInfo-2EjvR";
var _9 = "service__header-3OfLT";
var _a = "seat-1KmaV";
var _b = "seat_recommend-tz0Lr";
var _c = "seat_recommend_current-EAzSu";
var _d = "seat_business-32z0F";
var _e = "seat_occupied-2lkVR";
var _f = "seat__number-t1PvS";
var _10 = "seat__price-1XZYX";
var _11 = "seat__extendedIcon-3MTFp";
var _12 = "seat_withZeroPrice-MHwAS";
var _13 = "seatsInfo__priceWrp-2kCJt";
var _14 = "passenger-3_xxR";
var _15 = "passenger_active-bqPzc";
var _16 = "passenger__select-GfUJY";
var _17 = "passenger__number-3X287";
var _18 = "passenger__name-3cgai";
var _19 = "recommend-O0QPr";
var _1a = "recommend__icon-J9dvr";
var _1b = "passenger_recommend-1kfdD";
var _1c = "passenger__payload-2S5D6";
var _1d = "suggestionModal__content-1ytpH";
var _1e = "passenger__price-3rUoK";
var _1f = "passenger__main-iELfS";
var _20 = "seatDetails-2Y4qT";
var _21 = "confirm-24-Tt";
var _22 = "clear-2fQ2Z";
var _23 = "airplane-4ld8j";
var _24 = "container-1KSaV";
var _25 = "details-2-l37";
var _26 = "passenger__seat-22PuZ";
var _27 = "passenger__selectMobile-1lFoB";
var _28 = "passenger__selectMobile_selected-2XE4i";
var _29 = "mobilePassenger-2nyBv";
var _2a = "seatmap_passengers_recommend-3oFqg";
var _2b = "seatmap_passengers_footer-3EDFe";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "recommend__wrapper", _4 as "tooltip", _5 as "tooltip_recommend", _6 as "info", _7 as "tooltip_popper", _8 as "tooltip_withInfo", _9 as "service__header", _a as "seat", _b as "seat_recommend", _c as "seat_recommend_current", _d as "seat_business", _e as "seat_occupied", _f as "seat__number", _10 as "seat__price", _11 as "seat__extendedIcon", _12 as "seat_withZeroPrice", _13 as "seatsInfo__priceWrp", _14 as "passenger", _15 as "passenger_active", _16 as "passenger__select", _17 as "passenger__number", _18 as "passenger__name", _19 as "recommend", _1a as "recommend__icon", _1b as "passenger_recommend", _1c as "passenger__payload", _1d as "suggestionModal__content", _1e as "passenger__price", _1f as "passenger__main", _20 as "seatDetails", _21 as "confirm", _22 as "clear", _23 as "airplane", _24 as "container", _25 as "details", _26 as "passenger__seat", _27 as "passenger__selectMobile", _28 as "passenger__selectMobile_selected", _29 as "mobilePassenger", _2a as "seatmap_passengers_recommend", _2b as "seatmap_passengers_footer" }
export default { "__esModule": _1, "tabletMiddle": _2, "recommend__wrapper": _3, "tooltip": _4, "tooltip_recommend": _5, "info": _6, "tooltip_popper": _7, "tooltip_withInfo": _8, "service__header": _9, "seat": _a, "seat_recommend": _b, "seat_recommend_current": _c, "seat_business": _d, "seat_occupied": _e, "seat__number": _f, "seat__price": _10, "seat__extendedIcon": _11, "seat_withZeroPrice": _12, "seatsInfo__priceWrp": _13, "passenger": _14, "passenger_active": _15, "passenger__select": _16, "passenger__number": _17, "passenger__name": _18, "recommend": _19, "recommend__icon": _1a, "passenger_recommend": _1b, "passenger__payload": _1c, "suggestionModal__content": _1d, "passenger__price": _1e, "passenger__main": _1f, "seatDetails": _20, "confirm": _21, "clear": _22, "airplane": _23, "container": _24, "details": _25, "passenger__seat": _26, "passenger__selectMobile": _27, "passenger__selectMobile_selected": _28, "mobilePassenger": _29, "seatmap_passengers_recommend": _2a, "seatmap_passengers_footer": _2b }
